const filterCriterionDataType = {
    TYPE_TEXT : 1,

    TYPE_NUMBER : 2,

    TYPE_BOOLEAN : 3,

    TYPE_NUMBER_RANGE : 5,

    TYPE_DATE_RANGE : 6,

    TYPE_DATA_SET : 11,

    TYPE_USER_SELECT : 12

};

angular.module('gw-um-j2js')
    .constant('filterCriterionDataType', filterCriterionDataType);